import React from 'react';

import styled from 'styled-components';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box } from '@mui/material';

import Text from 'components/Text';
import { useIsMobile } from 'utils/mediaQueries';

interface Props {
  label?: string;
  onToggle?: () => void;
  onEnter?: () => void;
}

const Rail = styled.div<{ isMobile?: boolean }>`
  background: ${({ theme }) => theme.COLORS.BACKGROUND_SECONDARY};
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 8px;
  z-index: 10;

  ${({ isMobile }) =>
    isMobile
      ? `
    flex-direction: row;
    width: 100%;
    height: 56px;
    margin-right: 0;
    margin-bottom: 16px;
  `
      : `
    flex-direction: column;
    width: 56px;
    height: 30rem;
    margin-right: 16px;
    margin-bottom: 0;
  `}
`;

const RoundButton = styled.button`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.COLORS.PRIMARY};
  color: ${({ theme }) => theme.COLORS.BLACK_1};
`;

const VerticalLabel = styled.div`
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RoomVerticalRail: React.FC<Props> = ({ label = 'Resumo da sala', onToggle, onEnter }) => {
  const isMobile = useIsMobile();
  return (
    <Rail isMobile={isMobile}>
      <RoundButton aria-label="abrir" onClick={onToggle}>
        {isMobile ? <ExpandMoreIcon fontSize="small" /> : <ChevronRightIcon fontSize="small" />}
      </RoundButton>

      {(!isMobile && (
        <VerticalLabel>
          <Text size="xSmall">{label}</Text>
        </VerticalLabel>
      )) || (
        <Box display="flex" alignItems="center" justifyContent="center">
          <Text size="small">{label}</Text>
        </Box>
      )}

      {/* <BottomButton aria-label="entrar" onClick={onEnter}>
        <MeetingRoomIcon fontSize="small" />
      </BottomButton> */}
      <div></div>
    </Rail>
  );
};

export default RoomVerticalRail;
